import { Controller } from "@hotwired/stimulus"
import pageMessageBroker from "../page_message_broker"

// Connects to data-controller="breakdown-modal-trigger"
export default class extends Controller {
  static values = {
    renewalId: String
  }

  connect() {
    console.log("BreakdownModalTriggerController connected")
  }

  open() {
    console.log("Dispatching open-breakdown-modal event")
    pageMessageBroker.dispatch("open-breakdown-modal", {
      renewalId: this.renewalIdValue
    })
  }
}